import React, { useState, useEffect, useContext } from 'react';
import Spinner from 'react-bootstrap/Spinner';
import Button from 'react-bootstrap/Button';
import { Col, Row, Form } from "react-bootstrap";
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import ToggleButton from 'react-bootstrap/ToggleButton';
import Modal from 'react-bootstrap/Modal'
import { useTranslation } from 'react-i18next';
import { postContentWithAction, getContentWithAction } from '../../apiConnect';
import AppContext from '../../AppContext';
import { nutrientNumberCellStyle } from '../ComponentStyles/ButtonStyles.js'
import * as harvestConstants from '../../Constants/HarvestConstants.js';

import '../../css/general.css'
import '../../css/farmPlot.css'

const StorageInfoModal = (props) => {
    const { auth } = useContext(AppContext);
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState(true);
    const [title, setTitle] = useState("");
    const [storageData, setStorageData] = useState(null);

    /* For harvest storages */
    const [selectedUnit, setSelectedUnit] = useState(null);
    const [unitOptions, setUnitOptions] = useState([]);
    const [baleCount, setBaleCount] = useState(0);
    const harvestUnitsGroup = [
        { name: t('UnitBale'), value: harvestConstants.BALE_UNIT.toString() }
    ]

    useEffect(() => {
        setTitle(t('Storage'));
        setStorageData(props.selectEvent.selectedElement);

        // If storage is a harvest storage, get the bale count
        if (props.selectEvent.selectedElement.purchaseProducts.length &&
            props.selectEvent.selectedElement.propertyType === harvestConstants.STORAGE_PROPERTY_TYPE_HARVEST) {
            buildUnitOptions(props.selectEvent.selectedElement);
            Promise.all([
                getContentWithAction(auth.getAccessToken(), 'harvest', 'harvests', { plotId: 0 }),
                getContentWithAction(auth.getAccessToken(), 'resource', 'storages', { })
            ]).then(([harvests, storages]) => {
                let selectedStorage = storages.find(s => s.externalStorageId === props.selectEvent.selectedElement.storageId);
                if (selectedStorage) {
                    let storageHarvests = harvests.filter(h => h.storageId === selectedStorage.id);
                    if (storageHarvests.length) {
                        let totalLoadAmount = storageHarvests.map(h => h.loadAmount)
                            .reduce((a, acur) => a + acur, 0)
                        setBaleCount(totalLoadAmount);
                        setSelectedUnit(props.selectEvent.selectedElement.purchaseProducts[0].unitType.toString());
                    }
                    else {
                        setBaleCount(null);
                        setSelectedUnit(null);
                    }
                }
            });
        }
        
        setIsLoading(false);
    }, [props.selectEvent.storage]);

    const buildUnitOptions = (storage) => {
        var options = [];
        if (storage.purchaseProducts[0].unitType === harvestConstants.KG_UNIT_TYPE) {
            options.push({ name: t('UnitKg'), value: harvestConstants.KG_UNIT_TYPE.toString() });
        }
        else if (storage.purchaseProducts[0].unitType === harvestConstants.DRY_CONTENT_UNIT_TYPE) {
            options.push({ name: t('UnitKgDM'), value: harvestConstants.DRY_CONTENT_UNIT_TYPE.toString() });
        }
        options.push(...harvestUnitsGroup);
        setUnitOptions(options);
    }

    const getProductAmount = (product) => {
        if (selectedUnit === harvestConstants.BALE_UNIT.toString()) {
            return baleCount;
        }

        return product.amount + " " + product.unitText;
    }

    return (
        <>
            <Modal show={props.show} onHide={props.onHide}>
                <Modal.Header closeButton>
                    <Modal.Title className="text-dark">
                        {title}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {isLoading ? <Spinner as="span" className="center" animation="border" role="status" variant="secondary" /> :
                    <div>
                            {!storageData.purchaseProducts ? <p>{t('Storage_Empty')}</p> :
                                <Form>
                                    {storageData.propertyType === harvestConstants.STORAGE_PROPERTY_TYPE_HARVEST && selectedUnit ? 
                                        <ButtonGroup className="harvest-unit-group">
                                            {unitOptions.map((radio, i) => (
                                                <ToggleButton
                                                    key={i}
                                                    id={radio.name + i}
                                                    type="radio"
                                                    variant="outline-success"
                                                    name="radio"
                                                    value={radio.value}
                                                    checked={selectedUnit === radio.value}
                                                    onChange={(e) => {
                                                        setSelectedUnit(e.currentTarget.value);
                                                    }}
                                                >
                                                    {radio.name}
                                                </ToggleButton>
                                            ))}
                                        </ButtonGroup>
                                        : ''}

                                    {/* HEADERS */}
                                    <div>
                                        <Form.Group className="nutrient-table-header">
                                            <Row className="nutrient-table-title" >
                                                <Col xs={10}>
                                                    { storageData.name }
                                                </Col>
                                            </Row>
                                            <Row className="storage-header-row" >
                                                <Col xs={6} className="storage-row">
                                                    <b>{t('Product')}</b>
                                                </Col>
                                                <Col xs={6} className="storage-row" style={nutrientNumberCellStyle}>
                                                    <b>{t('Inventory_Amount')}</b>
                                                </Col>
                                            </Row>
                                        </Form.Group>
                                    </div>

                                    <Form.Group className="nutrient-table" key={'001'}>
                                        {storageData.purchaseProducts.map((product, i) => (
                                            <Row className="nutrient-data-row" key={i}>
                                                <Col xs={8} className="storage-row">
                                                    {product.name}
                                                </Col>
                                                <Col xs={4} className="storage-row" style={nutrientNumberCellStyle}>
                                                    {getProductAmount(product)}
                                                </Col>
                                            </Row>
                                        ))}
                                    </Form.Group>
                                </Form>
                            }
                    </div>
                    }
                </Modal.Body>
                <Modal.Footer className="modal-footer-right-align">
                    <Button variant="outline-secondary" onClick={props.onHide}>{t('Close')}</Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default StorageInfoModal;